import { ReportRequest } from '@/client/reports/types/reports.type';
import { useVulnerableUsersOverTimeReports } from '@/hooks/query';
import { useAppSelector } from '@/hooks/store';
import { selectCurrentAccount } from '@/store/features/account/current-account.slice';
import { AccordionTabHeader } from '@/ui/accordion';
import { LineChartFilled } from '@/ui/charts/bar-chart';
import { FlexContainer } from '@/ui/styled-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const ChartContainer = styled(FlexContainer)`
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border: 1px solid var(--gray-medium);
  border-radius: var(--xsmall-border-radius);
  padding: var(--default-padding);
  background: var(--white-main);
`;

const mockData = [
  { period: '08-2024', percentageRiskyUsers: 7 },
  { period: '09-2024', percentageRiskyUsers: 9 },
  { period: '10-2024', percentageRiskyUsers: 12 },
  { period: '11-2024', percentageRiskyUsers: 7 },
  { period: '12-2024', percentageRiskyUsers: 6 },
  { period: '01-2025', percentageRiskyUsers: 4 },
  { period: '02-2025', percentageRiskyUsers: 7 },
  { period: '03-2025', percentageRiskyUsers: 9 },
  { period: '04-2025', percentageRiskyUsers: 4 },
  { period: '05-2025', percentageRiskyUsers: 10 },
  { period: '06-2025', percentageRiskyUsers: 6 },
  { period: '07-2025', percentageRiskyUsers: 4 },
];

type VulnerableUsersOverviewProps = {
  filters: ReportRequest;
};

export const VulnerableUsersOverview = ({
  filters,
}: VulnerableUsersOverviewProps) => {
  const { t } = useTranslation();
  const currentAccount = useAppSelector(selectCurrentAccount);
  const { isLoading } = useVulnerableUsersOverTimeReports(
    currentAccount?.id as string,
    filters,
  );

  return (
    <ChartContainer id="vulnerable-users-chart">
      <AccordionTabHeader
        title={t('phishing.simulation.usersOverview.header')}
        description={t('phishing.simulation.usersOverview.description')}
        isSubHeader
      />
      <LineChartFilled
        reportData={mockData}
        isLoading={isLoading}
        fromDate={filters.from}
        toDate={filters.to}
      />
    </ChartContainer>
  );
};
